// extracted by mini-css-extract-plugin
var _1 = "header_cardContainer__21Yu1";
var _2 = "header_container__r6Qye";
var _3 = "header_feature__wX7dD";
var _4 = "header_fffCard__baeZU";
var _5 = "header_promoFeatures__6XOWb";
var _6 = "header_row__ymcwm";
var _7 = "header_sendGiftLink__M5tSd";
var _8 = "header_subtitle__HPs9R";
var _9 = "header_title__KHTrN";
export { _1 as "cardContainer", _2 as "container", _3 as "feature", _4 as "fffCard", _5 as "promoFeatures", _6 as "row", _7 as "sendGiftLink", _8 as "subtitle", _9 as "title" }
